export default (function (search) {
  return search.replace(/^\?/, '');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/url-utils/es/trimSearch.js
// module id = 535
// module chunks = 0